module.exports = __webpack_public_path__ + "static/img/icon-play.fc8a0144.svg";